import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import history from 'routing/history';
import usePageType from 'hooks/usePageType';
import Button from 'components/Button';
import DownloadAppModal from 'products/nomad_insurance/components/DownloadAppModal';
import InsuranceIcon from 'products/nomad_insurance/assets/img/icons/insurance.svg';
import ReferralIcon from 'products/nomad_insurance/assets/img/icons/detailsMenu/gift-white.svg';
import AppIcon from 'products/nomad_insurance/assets/img/icons/mobile.svg';
import { Logo, Link, ProductNavbar, ProfileMenu } from './styled';

const DesktopNavigation = ({ isVisible, transparent, ...restProps }) => {
  const basePath = '/nomad-insurance';
  const navigateToHome = () => history.push(basePath);
  const { isHomepage } = usePageType();
  const { user, isInitInProgress } = useSelector((state) => state.app);
  const { planholder } = useSelector((state) => state.nomadInsurance.planholder);
  const { referralLink } = useSelector((state) => state.nomadInsurance.referrals);
  const { isAuthenticated } = user;

  const [isDownloadAppModalOpen, setIsDownloadAppModalOpen] = useState(false);

  const items = () => {
    if (!planholder || !planholder.hasCompletedProfile) {
      return [{ label: 'Register', url: `${basePath}/registration` }];
    }

    const arr = [
      { label: 'Show profile', url: `${basePath}/profile`, icon: InsuranceIcon }
    ];

    if (referralLink) {
      arr.push({
        label: 'Refer a friend',
        url: '/nomad-insurance/profile/my-details/send-a-gift',
        icon: ReferralIcon
      });
    }

    arr.push({
      label: 'Download mobile app',
      onClick: () => setIsDownloadAppModalOpen(true),
      icon: AppIcon
    });
    return arr;
  };

  return (
    <>
      <DownloadAppModal
        isOpen={isDownloadAppModalOpen}
        onClose={() => setIsDownloadAppModalOpen(false)}
      />
      <ProductNavbar
        isVisible={isVisible}
        transparent={transparent}
        isHomepage={isHomepage}
        {...restProps}
      >
        <Logo onClick={navigateToHome} />
        <Link exact to="/nomad-insurance/faq">
          FAQ
        </Link>

        {isAuthenticated && !isInitInProgress && (
          <ProfileMenu
            label="My Nomad Insurance"
            variant="dark"
            position="left"
            dropdownSize="large"
            items={items()}
          />
        )}
        {!isAuthenticated && !isInitInProgress && (
          <Button onClick={() => history.push('/nomad-insurance/signup')}>Sign up</Button>
        )}
      </ProductNavbar>
    </>
  );
};

DesktopNavigation.defaultProps = {
  isVisible: false,
  transparent: false
};

DesktopNavigation.propTypes = {
  isVisible: PropTypes.bool,
  transparent: PropTypes.bool
};

export default DesktopNavigation;
